// extracted by mini-css-extract-plugin
module.exports = {"pt-notes-table":"pt-notes-table-653d7d11673e7181feb30a6fc1e6ace4"};